import { css, keyframes } from "styled-components";

/** 분위기 이름 → 배경 (그림 없이 색으로만) */
export const MOODS = {
  기본: "radial-gradient(120% 90% at 50% 10%, #2a2a30 0%, #141417 70%)",
  밤: "radial-gradient(120% 80% at 70% 0%, #1f2a44 0%, #0d1220 55%, #07090f 100%)",
  새벽: "linear-gradient(180deg, #1b2440 0%, #3b3f63 55%, #8a7c8f 100%)",
  아침: "linear-gradient(180deg, #e9e4da 0%, #d8d2c6 60%, #c9c2b3 100%)",
  낮: "linear-gradient(180deg, #f4f1ea 0%, #e6e1d6 100%)",
  사무실: "linear-gradient(180deg, #d9dde1 0%, #b9c0c7 70%, #9aa3ad 100%)",
  카페: "radial-gradient(110% 80% at 30% 20%, #6b4a33 0%, #3a2618 60%, #21150d 100%)",
  방: "radial-gradient(90% 70% at 80% 85%, #4a3a24 0%, #1d1812 60%, #0f0c09 100%)",
  비: "linear-gradient(180deg, #2b3440 0%, #1b222b 60%, #11161c 100%)",
  노을: "linear-gradient(180deg, #2c2346 0%, #8a4b5c 55%, #e3936a 100%)",
};

/** 밝은 분위기에서는 글자를 어둡게 */
export const LIGHT_MOODS = ["아침", "낮", "사무실"];

export const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const slideDown = keyframes`
  0%   { opacity: 0; transform: translateY(-120%); }
  60%  { opacity: 1; transform: translateY(6%); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const shake = keyframes`
  0%, 100% { transform: translate(0, 0); }
  15% { transform: translate(-6px, 2px); }
  30% { transform: translate(5px, -3px); }
  45% { transform: translate(-4px, 3px); }
  60% { transform: translate(3px, -2px); }
  75% { transform: translate(-2px, 1px); }
`;

export const pulse = keyframes`
  0%, 100% { opacity: 0; }
  12% { opacity: 1; }
  25% { opacity: 0.15; }
  37% { opacity: 0.8; }
  60% { opacity: 0; }
`;

export const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-7px); }
`;

export const drift = keyframes`
  from { transform: translate3d(-4%, -2%, 0) scale(1); }
  to   { transform: translate3d(4%, 3%, 0) scale(1.08); }
`;

export const rain = keyframes`
  from { background-position: 0 0, 0 0; }
  to   { background-position: -60px 600px, -30px 400px; }
`;

export const blink = keyframes`
  0%, 100% { opacity: 0.25; }
  50%      { opacity: 0.9; }
`;

/** '움직임 줄이기' 설정이면 애니메이션 끄기 */
export const noMotion = css`
  @media (prefers-reduced-motion: reduce) {
    animation: none !important;
  }
`;
